import { render } from "./nav_panel.vue?vue&type=template&id=87bf5564"
import script from "./nav_panel.js?vue&type=script&lang=js"
export * from "./nav_panel.js?vue&type=script&lang=js"

import "./nav_panel.vue?vue&type=style&index=0&id=87bf5564&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__